var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGarageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 20",
    width: 21,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "garage-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ff385c } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m2.9 16.4v1.1q0 0.3 0.2 0.6 0.3 0.2 0.6 0.2h0.9q0.3 0 0.6-0.2 0.2-0.3 0.2-0.6v-0.8h10v0.8q0 0.3 0.2 0.6 0.3 0.2 0.6 0.2h0.9q0.3 0 0.6-0.2 0.2-0.3 0.2-0.6v-1.1q0.4-0.2 0.6-0.6 0.2-0.4 0.2-0.8v-2.5c0-0.7-0.4-1.3-1-1.5l-1.1-3.5c-0.2-0.5-0.5-0.9-0.9-1.2-0.5-0.3-1-0.5-1.5-0.5h-7.6c-0.5 0-1 0.2-1.5 0.5-0.4 0.3-0.7 0.7-0.9 1.2l-1.1 3.5q-0.5 0.2-0.8 0.6-0.2 0.4-0.2 0.9v2.5c0 0.6 0.3 1.1 0.8 1.4zm2.1-1.4q-0.3 0-0.5-0.1-0.2-0.1-0.4-0.3c-0.2-0.2-0.4-0.5-0.4-0.9 0-0.3 0.2-0.6 0.4-0.8 0.2-0.3 0.6-0.4 0.9-0.4 0.3 0 0.6 0.1 0.9 0.4 0.2 0.2 0.3 0.5 0.3 0.9 0 0.3-0.1 0.6-0.3 0.8-0.3 0.3-0.6 0.4-0.9 0.4zm10.8 0c-0.3 0-0.6-0.1-0.9-0.4-0.2-0.2-0.3-0.5-0.3-0.9 0-0.3 0.1-0.6 0.3-0.8 0.3-0.3 0.6-0.4 0.9-0.4 0.3 0 0.7 0.1 0.9 0.4 0.2 0.2 0.4 0.5 0.4 0.9 0 0.3-0.2 0.6-0.4 0.8-0.2 0.3-0.6 0.4-0.9 0.4zm-9.2-7.5h7.6q0.3 0 0.5 0.2 0.2 0.1 0.3 0.4l0.9 2.7h-11l0.9-2.7c0.1-0.4 0.4-0.6 0.8-0.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m18.7 6.2v-1.8l-8-2.7q-0.3-0.1-0.6 0l-8 2.9v1.8l8.3-3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarageIcon);
export default __webpack_public_path__ + "static/media/garage-icon.42374c7a4ae8d5b35be0acc5218d999a.svg";
export { ForwardRef as ReactComponent };